import React, { Component } from 'react';
import FlipCard from './FlipCard';
import { addToArray, removeFromArray } from '../../utils/immutable';
import './styles.styl';

class FlipCardContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      cardsFlipped: [],
      flipping: []
    };
  }

  handleClick = i => {
    const { cards } = this.props.data;
    const title = cards[i].title;

    // This will need to keep track of what has flipped, and then trigger based on that.
    if (
      title &&
      (!this.props.input || this.props.input.indexOf(title) === -1)
    ) {
      const newInput = addToArray(this.props.input, cards[i].title); // nah, this isn't me.

      this.props.onInput(newInput);
      if (newInput.length === this.props.data.cards.length) {
        this.props.onCompletion(true);
        // TODO replace onCompletion with setSubmitStatus to enable feedback if that is needed with this module.
      }
    }
  };

  lockCard = index => {
    const { flipping } = this.state;
    return this.setState({
      flipping: [...flipping, index]
    });
  };

  unlockCard = index => {
    const { flipping } = this.state;
    let newFlippingArray = removeFromArray(flipping, index);
    
    return this.setState({
      flipping: newFlippingArray
    });
  };

  render() {
    const { input } = this.props;
    const { cards } = this.props.data;
    const { flipping } = this.state;

    return (
      <div className="comet-cards">
        {cards.map((card, i) => {
          return (
            <FlipCard
              key={i}
              data={card}
              index={i}
              onClick={this.handleClick}
              flipping={flipping.indexOf(i) > -1}
              lockCard={this.lockCard}
              unlockCard={this.unlockCard}
              seen={input && input.indexOf(card.title) > -1}
            />
          );
        })}
        <div className="comet-card comet-card--invisible" />
        <div className="comet-card comet-card--invisible" />
        <div className="comet-card comet-card--invisible" />
      </div>
    );
  }
}

export default FlipCardContainer;



// WEBPACK FOOTER //
// ../core/src/components/FlipCards/FlipCardContainer.js